import Index from "@/views/Index";
import i18n from "@/plugins/i18n";

const studentRoutes = [
    {
        path: "/",
        name: "StudentArea",
        component: () => import("../layout/MainLayout"),
        children: [
            /* Dashboard */
            {
                path: "/dashboard",
                name: "Dashboard",
                component: () => import("../views/student/dashboard/StudentDashboard"),
                meta: {name: "Student Dashboard"},
            },
            /* Course */
            {
                path: "/course", component: Index, children: [
                    {
                        path: "list",
                        name: "CoursesList",
                        component: () => import("../views/student/course/ListCourse"),
                        meta: {name: i18n.t("list of courses")},
                    },
                    {
                        path: ":id",
                        name: "CourseDetail",
                        component: () => import("../views/student/course/CourseDetail"),
                        meta: {name: i18n.t("Detail course"), menuShow: "CoursesList"},
                    },
                ],
            },
            /* LiveClass */
            {
                path: "/live-class", component: Index, children: [
                    {
                        path: "list",
                        name: "LiveClassList",
                        component: () => import("../views/student/liveclass/ListLiveClass"),
                        meta: {name: i18n.t("Live classes"), menuShow: "LiveClassList"}
                    },
                    {
                        path: ":id",
                        name: "LiveClassDetail",
                        component: () => import("../views/student/liveclass/detail/LiveClassDetail"),
                        meta: {name: i18n.t("Detail live class"), menuShow: "LiveClassList"},
                    }
                ]
            },
            /* Profile */
            {
                path: "/user", component: Index, children: [
                    {
                        path: "profile",
                        name: "Profile",
                        component: () => import("../views/student/profile/Profile"),
                        meta: {name: i18n.t("Profile"), menuShow: "Dashboard"}
                    }
                ]
            },
            /* Score record */
            {
                path: "/scoreRecord", component: Index, children: [
                    {
                        path: "list",
                        name: "ScoreRecordList",
                        component: () => import("../views/student/scoreRecord/ListScoreRecord"),
                        meta: {name: i18n.t("Score record")}
                    }
                ]
            },

            /* Note record */
            {
                path: "/noteRecord", component: Index, children: [
                    {
                        path: "list",
                        name: "NoteRecordList",
                        component: () => import("../views/student/noteRecord/ListNoteRecord"),
                        meta: {name: i18n.t("Note record")}
                    }
                ]
            },

            /* Library */
            {
                path: "/library", component: Index, children: [
                    {
                        path: "list",
                        name: "LibraryList",
                        component: () => import("../views/student/library/ListLibrary"),
                        meta: {name: i18n.t("Library")}
                    }
                ]
            },
            /* quizTest */
            {
                path: "/exam", component: Index, children: [
                    {
                        path: "list",
                        name: "Exam",
                        component: () => import("../views/student/exam/Exam"),
                        meta: {name: i18n.t("Exam-Test"), menuShow: "Exam"}
                    }
                ]
            },
            /* schedule */
            {
                path: "/schedule", component: Index, children: [
                    {
                        path: "list",
                        name: "ScheduleList",
                        component: () => import("../views/student/schedule/ListSchedule"),
                        meta: {name: i18n.t("Student schedule"), menuShow: "ScheduleList"}
                    }
                ]
            },

            {
                path: "/myNotification", component: Index, children: [
                    {
                        path: "list",
                        name: "MyNotification",
                        component: () => import("../views/teacher/notification/MyNotification"),
                        meta: {name: i18n.t("Notification")}
                    },
                    {
                        path: "detail/:id",
                        name: "NotificationDetail",
                        component: () => import("../views/teacher/notification/NotificationDetail"),
                        meta: {name: i18n.t("Notification")}
                    }
                ]
            },

        ]
    },
    /* lesson */
    {
        path: "/course/:id/lesson/:idLesson",
        name: "LessonDetail",
        component: () => import("../views/student/lesson/LessonDetail"),
        meta: {name: i18n.t("Video lesson"), menuShow: "CoursesList"}
    },
]

export default studentRoutes;
